import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import ModalityGroundIcon from './HomeIcon';
import ModalityOnlineIcon from './OnlineIcon';
import ToggleButton from './ToggleButton';

export { ModalityGroundIcon, ModalityOnlineIcon };

export const isGround = (institutionInfo) => {
  return ['Both', 'Ground'].includes(
    institutionInfo && institutionInfo.degree_option
  );
};

export const isOnline = (institutionInfo) => {
  return ['Both', 'Online'].includes(
    institutionInfo && institutionInfo.degree_option
  );
};

const ToggleButtonModality = ({
  color,
  className,
  onClick,
  value = false,
  disabled,
  ariaLabel,
}) => {
  const { t } = useTranslation();

  return (
    <ToggleButton
      color={color}
      className={classNames({
        'toggle-button-modality': true,
        [className]: className,
      })}
      ariaLabel={ariaLabel}
      value={value}
      onClick={onClick}
      disabled={disabled}
      showLabel
      id="online-in-person-toggle"
      onLabel={[
        <ModalityOnlineIcon
          key="icon-1"
          className="toggle-button-modality-icon"
          color={value && !disabled ? color : 'inherit'}
        />,
        <p
          key="text"
          className="toggle-button-modality-text"
          style={{
            color: value && !disabled ? color : 'inherit',
          }}
        >
          {t('Offered online')}
        </p>,
      ]}
      offLabel={[
        <div style={{ display: 'flex' }} aria-label="Any">
          <ModalityGroundIcon
            key="icon-1"
            className="toggle-button-modality-icon"
            color={value ? 'inherit' : color}
            desc={null}
          />
          <div
            key="divider"
            className="toggle-button-modality-icon-divider"
            style={{ background: value ? undefined : color }}
          />
          <ModalityOnlineIcon
            key="icon-2"
            data-cy="online-icon"
            className="toggle-button-modality-icon"
            color={value ? 'inherit' : color}
            desc={null}
          />
        </div>,
        <p
          key="text"
          className="toggle-button-modality-text"
          style={{ color: value ? 'inherit' : color }}
        >
          {t('Any')}
        </p>,
      ]}
    />
  );
};

export default ToggleButtonModality;

ToggleButtonModality.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export const ModalityIcons = ({ className, degree }) => {
  const icons = [];
  const institutionInfo =
    degree && degree.institution_info && degree.institution_info[0];

  if (isGround(institutionInfo)) {
    icons.push(
      <ModalityGroundIcon
        data-cy="degree-icon-ground"
        key="ground"
        className={className}
        color={null}
        title="On campus"
        desc="Degree is offered on campus."
      />
    );
  }

  if (isOnline(institutionInfo)) {
    icons.push(
      <ModalityOnlineIcon
        data-cy="degree-icon-online"
        key="online"
        className={className}
        color={null}
        title="Online"
        desc="Degree is offered online."
      />
    );
  }

  return <div className="modality-icons__container">{icons}</div>;
};

ModalityIcons.propTypes = {
  className: PropTypes.string,
  degree: PropTypes.shape({
    institution_info: PropTypes.arrayOf(
      PropTypes.shape({
        institution_name: PropTypes.string,
        degree_option: PropTypes.string,
        url: PropTypes.string,
      })
    ),
  }),
};
